export enum AUTH0_ROLE {
  NONE = '',
  PROSPECT = 'Prospect',
  CLIENT = 'Client',
  BUSINESS = 'Business',
  ADMIN = 'Admin',
  SIGNUP = 'Signup',
  TRIAL = 'Trial',
  EXPIRED = 'Expired'
}

export interface UserProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: AUTH0_ROLE;
  account: string;
  trialDaysLeft: number | null;
  companyName?: string;
}
